import MigrateTab from "../MigrateTab";

const COLUMN_HEADERS = [
    { key: 'total', label: 'Total Inventario', value: 'allPropertiesCount' },
    { key: 'total_to_migrate', label: 'Total a migrar', value: 'propertiesToMigrateCount' },
    { key: "full_name", label: "Nombre", value: "full_name" },
    { key: 'email', label: 'Correo electrónico', value: 'email' },
    { key: 'user_phone', label: 'Numero de telefono', value: 'user_phone' },
    { key: "feed_name", label: "Nombre del feed", value: "feed_name" },
    { key: "more_info_date", label: "Fecha de solicitud", value: "more_info_date" },
    { key: 'actions', label: 'Acciones', value: 'actions' },
];

const MigrateMoreInfo = () => {
    return <MigrateTab columnHeaders={COLUMN_HEADERS} type="moreInfo" />;
}

export default MigrateMoreInfo;